import http from "../http-common";

class ConvertService {

    convertFile(data) {
        return http.post("/convert",data);
    }
}

export default new ConvertService();